<template>
  <div style="display: inline-block" id="page">
    <div class="allPage" :class="explain ? 'd_flex' : ''">
      <div>
        <span @click="fistPage()" class="botton"
          ><i
            class="icon iconfont icondouble-arrow-left"
            style="
              display: inline-block;
              font-weight: 100;
              transform: scale(0.8);
            "
          ></i
        ></span>
        <span @click="prevPage()" class="botton"
          ><i
            class="icon iconfont iconicon_12"
            style="display: inline-block"
          ></i
        ></span>
        <!-- <span>{{ newPage }}</span> -->
        <span
          @click="thisPage(list)"
          :key="index"
          v-for="(list, index) in pageList"
          :class="list === newPage ? 'num active' : 'num'"
          >{{ list }}</span
        >
        <!-- <span class="little">···</span> -->
        <span @click="nextPage()" class="botton"
          ><i class="icon iconfont iconicon_9" style="display: inline-block"></i
        ></span>
        <span @click="lastPage()" class="botton"
          ><i
            class="icon iconfont icondouble-arrow-left1"
            style="
              display: inline-block;
              font-weight: 100;
              transform: scale(0.8);
            "
          ></i
        ></span>
        <span style="margin-left: 10px">跳转</span>
        <input v-model="goPage" type="text" />
        <span>页</span>
        <span @click="goToPage()" class="go">GO</span>
      </div>
      <div v-if="explain === 0"></div>
      <div v-if="explain === 1">
        共{{ totalPage }}页，共{{ totalCount }}条记录
      </div>
      <div v-if="explain === 2" class="colorZh">*规则之间是“或者”的关系</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page',
  props: [
    'totalPage',
    'page',
    'explain',
    'totalCount'
  ],
  data () {
    return {
      newotalPage: this.totalPage,
      newPage: this.page,
      pageList: [],
      goPage: '1'
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    console.log(this.newPage)
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getPageList()
  },
  methods: { // 所有的方法封装
    getPageList () {
      this.pageList = []
      if (this.newotalPage <= 10) {
        for (let i = 1; i <= this.newotalPage; i++) {
          this.pageList.push(i)
        }
      } else {
        if (this.newotalPage - this.newPage <= 10) {
          for (let i = this.newotalPage - 10; i <= this.newotalPage; i++) {
            this.pageList.push(i)
          }
        } else {
          if (this.newPage > 5) {
            for (let i = this.newPage - 4; i <= this.newPage + 5; i++) {
              this.pageList.push(i)
            }
          } else {
            for (let i = 1; i <= 9; i++) {
              this.pageList.push(i)
            }
          }
        }
      }
    },
    fistPage () {
      this.getPageList()
      this.$emit('on-getList', 1)
    },
    lastPage () {
      this.getPageList()
      this.$emit('on-getList', this.newotalPage)
    },
    prevPage () {
      // console.log(this.page)
      if (this.newPage > 1) {
        // console.log(this.newPage)
        this.newPage--
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    nextPage () {
      if (this.newPage < this.newotalPage) {
        // console.log(this.newPage)
        this.newPage++
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      }
    },
    thisPage (page) {
      this.newPage = page
      this.getPageList()
      this.$emit('on-getList', this.newPage)
    },
    goToPage () {
      const num = /[0-9]/
      if (num.test(this.goPage) && this.goPage !== '0' && parseInt(this.goPage, 0) <= this.newotalPage) {
        this.newPage = parseInt(this.goPage, 0)
        this.getPageList()
        this.$emit('on-getList', this.newPage)
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '页码不正确',
          content: '请输入正确的页数',
          stayTime: 2
        })
      }
    }
  },
  components: {
  },
  watch: {
    totalPage (value) {
      console.log(value)
      this.newotalPage = value
      this.getPageList()
    },
    page (value) {
      this.newPage = value
      this.getPageList()
    }
  }
}
</script>

<style scoped>
.allPage {
  text-align: right;
  /*padding:20px 10px;*/
}
.allPage .botton,
.allPage .num,
.allPage .go {
  border-radius: 100px;
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  vertical-align: middle;
  margin: 2px;
  cursor: pointer;
}
.allPage .num {
  border: 1px solid #eee;
  transition: all 0.5s;
}
.allPage .num.active {
  background: #e31d1a;
  color: #fff;
  width: 40px;
}
.allPage .num:hover {
  background: #e31d1a;
  color: #fff;
}
.allPage .botton {
  border: 1px solid #737373;
  color: #737373;
  width: 24px;
  height: 24px;
  line-height: 22px;
  font-weight: bold;
  transition: all 0.5s;
}
.allPage .botton:hover {
  border: 1px solid #fff;
  background: #e31d1a;
  color: #fff;
}
.allPage .botton i {
  font-size: 12px !important;
}
.allPage input {
  width: 32px;
  height: 17px;
  text-align: center;
  border: none;
  outline: none;
  padding: 5px;
  background: #f3f3f3;
  border-radius: 100px;
}
.allPage .go {
  background: #e31d1a;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/page.vue